import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters([
			'lang'
		])
	},
	methods: {
		t (key) {
			return this.$t(key, this.lang)
		},
		moment (date, format) {
			if (format) {
				return moment(date).locale(this.lang).format(format)
			} else {
				return moment(date).locale(this.lang)
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/translate.js